import { FC, useEffect, useMemo } from 'react'
import { Box, Input, Select } from '@chakra-ui/react'
import { UseFormRegister } from 'react-hook-form'

import { FormItem } from 'components'
import { PROFESSIONAL_CONTRACT_TYPE_INITIAL_FILTER_FIELDS } from 'InstitutionalManagement/constants/pages/professionalContractTypes'
import {
  ProfessionalContractTypeFieldsName,
  ProfessionalContractTypeFilterKeyString,
} from 'InstitutionalManagement/types'
import { STATUS_OPTIONS } from 'constants/variables'
import { focusElementById } from 'utils/events'

type Props = {
  hasPrefix?: boolean
  isOpen?: boolean
  register: UseFormRegister<ProfessionalContractTypeFilterKeyString>
  onlyFields?: ProfessionalContractTypeFieldsName[]
}

const ProfessionalContractTypeFilterForm: FC<Props> = ({ hasPrefix, isOpen = false, register, onlyFields }) => {
  const professionalContractTypeFilterFields = useMemo(() => {
    return onlyFields || PROFESSIONAL_CONTRACT_TYPE_INITIAL_FILTER_FIELDS
  }, [])

  function setPrefix(key: ProfessionalContractTypeFieldsName) {
    if (hasPrefix) return `professional_contract_type_${key}`
    return key
  }

  useEffect(() => {
    focusElementById('name')
  }, [isOpen])

  return (
    <Box>
      {professionalContractTypeFilterFields.includes('id') && (
        <FormItem label="ID" htmlFor="id">
          <Input id="id" {...register(setPrefix('id'))} />
        </FormItem>
      )}
      {professionalContractTypeFilterFields.includes('name') && (
        <FormItem label="Nome" htmlFor="name">
          <Input id="name" {...register(setPrefix('name'))} />
        </FormItem>
      )}
      {professionalContractTypeFilterFields.includes('description') && (
        <FormItem label="Descrição" htmlFor="description">
          <Input id="description" {...register(setPrefix('description'))} />
        </FormItem>
      )}
      {professionalContractTypeFilterFields.includes('status') && (
        <FormItem label="Status" htmlFor="status">
          <Select id="status" {...register(setPrefix('status'))}>
            {STATUS_OPTIONS.map(({ label, value }) => {
              return (
                <option key={value} value={value}>
                  {label}
                </option>
              )
            })}
          </Select>
        </FormItem>
      )}
    </Box>
  )
}

export default ProfessionalContractTypeFilterForm
